let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cddHY")).then(() => parcelRequire('992tZ'));